<script setup>
import {defineProps} from 'vue';

const props = defineProps({
    logo: {
        type: String,
        required: true,
    },
    name: String,
})
</script>

<template>
    <div class="relative z-0 flex-1 px-2 flex items-center justify-center sm:inset-0">
        <div class="w-full sm:max-w-xs flex items-center justify-center">
            <img class="block h-20 w-auto" :src="props.logo" :title="props.name"/>
        </div>
    </div>
</template>


